import React, { useState, useEffect, useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import '../styleDrawer.css';
import Snackbar from '@mui/material/Snackbar';
import {loadingCableDataComponent, loadingCableTypeDataComponent,
        loadingCouplingDataComponent, loadingFobDataComponent,
        loadingContractorDataComponent, loadingRankCableDataComponent,
        loadingRankComponentDataComponent, loadingOwnerWellDataComponent,
        loadingOwnerPillarDataComponent, loadingPonBoxDataComponent} from '../../LoadingData/LoadingDataComponents';
import CustomSnackbar from '../../Components/CustomSnackbar'; 
import CableContainerCanton from './ContainerEditCanton/CableContainerCanton'
import CouplingContainerCanton from './ContainerEditCanton/CouplingContainerCanton';
import FobContainerCanton from './ContainerEditCanton/FobContainerCanton'
import PonBoxContainerCanton from './ContainerEditCanton/PonBoxContainerCanton';
import {WriteLineOpticCanton} from '../../WriteData/WriteCantonCommunications'; 
import { WriteWellHighway, WritePillarHighway, WriteCouplingHighway, WriteFobHighway, WritePonBoxHighway, WritePillarManuallyCanton, WritePassiveNodeHighway } from '../../WriteData/WriteHighwayCommunications';   
import ManholeContainerSummit from '../DrawerEditSummit/ContainerEditSummit/ManholeContainerSummit';   
import PillarContainerSummit from '../DrawerEditSummit/ContainerEditSummit/PillarContainerSummit';  
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_SENIOR_MASTER } from '../../Constants/ConstantsOptics';
import PassiveNodeContainerCanton from './ContainerEditCanton/PassiveNodeContainerCanton';


const DrawerMenuEditCanton = ({ openEditCantonDrawer, toggleEditCantonDrawer, 
        handleCableSelectChange, handleLineStyleSelectChange, isLineDrawing,
         handleStartDrawing, handleStopDrawing,toggleManholeMarker,manholeMarker,
         togglePillarMarker, pillarMarker, toggleCouplingMarker, couplingMarker,
         toggleFobMarker, fobMarker, coordinatesManhole, setCoordinatesManhole,
         coordinatesPillar, setCoordinatesPillar, coordinatesCoupling, setCoordinatesCoupling,
         coordinatesFob, setCoordinatesFob, coordinatesCableLine, setCoordinatesCableLine, cableOpticId, 
         cableTypeId, cantonRefresh,setLengthCable,lengthCable, selectedRankCouling,
         setSelectedRankCoupling, handleChangeRankComponentCoupling, selectedRankFob, 
         setSelectedRankFob, handleChangeRankComponentFob, user, selectedCity, highwayTerritory, togglePonBoxMarker, 
         ponBoxMarker,coordinatesPonBox, setCoordinatesPonBox, cantonFobRefresh, cantonCouplingRefresh, cantonWellRefresh,
         cantonPillarRefresh, cantonPonBoxRefresh, cantonCablaRefresh, selectedCanton, selectedRegoin, selectedArea, role,
         cantonCablaByIdRefresh, togglePassiveNodeMarker, passiveNodeMarker, coordinatesPassiveNode, setCoordinatesPassiveNode,
         cantonPassiveNodeRefresh}) => {

      

//#region ПЕРЕМЕННЫЕ
  //Snackbar
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

  // Кабель 
  const [isVisibleCable, setIsVisibleCable] = useState(false);
  const [cableData, setCableData] = useState([]);
  const [cableTypeData, setCableTypeData] = useState([]);
  const [contractorData, setContractorData] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [selectedRankCable, setSelectedRankCable] = useState(null);
  const commentTextAreaRefCable = useRef(null);
  const [commentCable, setCommentCable] = useState('');
  const [selectedCable, setSelectedCable] = useState([]);
  const [selectedTypeCable, setSelectedTypeCable] = useState(null);
  const [rankCableData, setRankCableData] = useState([])
  const [selectedGroup, setSelectedGroup] = useState("Воздушка"); 
  const [isSubway, setIsSubway] = useState(false);  

  
useEffect(() => {

  if (selectedGroup === "Подземка") {
    setSelectedContractor(null);
  } else if (selectedGroup) {
    setSelectedContractor(1);
  }
  setSelectedCable([]);
  setSelectedTypeCable(null);
 }, [selectedGroup]);


  // Колодец
  const [isVisibleManhole, setIsVisibleManhole] = useState(false);
  const commentTextAreaRefManhole = useRef(null);
  const [commentManhole, setCommentManhole] = useState('');
  const [ownerWellData, setOwnerWellData] = useState(null);
  const [selectedOwnerWell, setSelectedOwnerWell] = useState([]);
  
  // Опора 
  const [isVisiblePillar, setIsVisiblePillar] = useState(false);
  const commentTextAreaRefPillar = useRef(null);
  const [commentPillar, setCommentPillar] = useState('');
  const [ownerPillarData, setOwnerPillarData] = useState(null);
  const [selectedOwnerPillar, setSelectedOwnerPillar] = useState([]);
  const [coordinatesManuallyPillae, setCoordinatesManuallyPillae] = useState(''); 
  const [manualInputEnabledPillar, setManualInputEnabledPillar] = useState(false);

  //Муфта
  const [isVisibleCoupling, setIsVisibleCoupling] = useState(false);
  const commentTextAreaRefCoupling = useRef(null);
  const [commentCoupling, setCommentCoupling] = useState('');
  const [couplingData, setCouplingData] = useState([]);
  const [selectedCoupling, setSelectedCoupling] = useState(null);
  const [rankComponentData, setRankComponentData] = useState([]);

  //Фоб
  const [isVisibleFob, setIsVisibleFob] = useState(false);
  const commentTextAreaRefFob = useRef(null);
  const [commentFob, setCommentFob] = useState('');
  const [fobData, setFobData] = useState([]);
  const [selectedFob, setSelectedFob] = useState(null);

  //Пон-бокс
   const [isVisiblePonBox, setIsVisiblePonBox] = useState(false);
   const commentTextAreaRefPonBox = useRef(null);
   const [commentPonBox, setCommentPonBox] = useState('');
  const [ponboxData, setPonBoxData] = useState([]);
   const [selectedPonBox, setSelectedPonBox] = useState(null);

  //Узел
  const [isVisiblePassiveNode, setIsVisiblePassiveNode] = useState(false);
 // const commentTextAreaRefFob = useRef(null);
 // const [commentFob, setCommentFob] = useState('');
  //const [fobData, setFobData] = useState([]);
  //const [selectedFob, setSelectedFob] = useState(null);
//#endregion  
  
//#region КАБЕЛЬ
// Кабель

const handleChangeContractor = (event) => {
  const selectedContractor = event.target.value;
  setSelectedContractor(selectedContractor);
};

const handleChangeRankCable = (event) => {
  const selectedRankCable = event.target.value;
  setSelectedRankCable(selectedRankCable);
};

function toggleVisibilityCable() {
  setIsVisibleCable(!isVisibleCable);
}

const handleCommentChangeCable = (event) => {
  setCommentCable(event.target.value);
}

// const handleChangeCableSelect = (event) => {
//   const selectedCable = event.target.value;
//   setSelectedCable(selectedCable);
// };

const handleChangeCableSelect = (selectedOption) => {
  if (!selectedOption) {
    // Если пользователь очистил выбор
    setSelectedCable([]);
    return;
  }

  setSelectedCable(selectedOption.value);
};

const handleChangeCableType = (event) => {
  const selectedTypeCable = event.target.value;
  setSelectedTypeCable(selectedTypeCable);
};

 const handleCableSave = async () => {
 
  WriteLineOpticCanton( coordinatesCableLine, commentTextAreaRefCable,selectedContractor, cableOpticId, cableTypeId,  
      isLineDrawing, showSnackbar, setCoordinatesCableLine, setCommentCable, setSelectedCable,
      setSelectedTypeCable,setSelectedContractor,cantonCablaRefresh, setLengthCable, lengthCable, 
      setSelectedRankCable,selectedRankCable, user, cantonCablaByIdRefresh);

      setIsSubway(false);
};


 
//#endregion  

//#region КОЛОДЕЦ
// Колодец

function toggleVisibilityManhole() {
  setIsVisibleManhole(!isVisibleManhole);
}

const handleCommentChangeManhole = (event) => {
  setCommentManhole(event.target.value);
}

const handleChangeOwnerWell = (event) => {
  const selectedOwnerWell = event.target.value;
  setSelectedOwnerWell(selectedOwnerWell);
};

async function wellSave(event) { 
  WriteWellHighway(event, coordinatesManhole, commentTextAreaRefManhole, selectedCity, manholeMarker, 
    showSnackbar, setCoordinatesManhole, setCommentManhole,cantonWellRefresh,
    selectedOwnerWell,setSelectedOwnerWell, user, highwayTerritory);
 
}
//#endregion  

//#region ОПОРА
// Опора

function toggleVisibilityPillar() {
  setIsVisiblePillar(!isVisiblePillar);
}

const handleChangeOwnerPillar = (event) => {
  const selectedOwnerPillar = event.target.value;
  setSelectedOwnerPillar(selectedOwnerPillar);
};

const handleCommentChangePillar = (event) => {
  setCommentPillar(event.target.value);
}

const handleInputChangePillar = (e) => {
  setCoordinatesManuallyPillae(e.target.value || ''); 
};

const toggleManualPillarInput = () => {
  setManualInputEnabledPillar(prev => !prev);
  setCoordinatesManuallyPillae('');
  setSelectedOwnerPillar([]);
  setCommentPillar('');
};

async function pillarSave(event) {
  WritePillarHighway(event, coordinatesPillar, commentTextAreaRefPillar, selectedCity, pillarMarker,
                     showSnackbar, setCoordinatesPillar, setCommentPillar,cantonPillarRefresh,
                     selectedOwnerPillar,setSelectedOwnerPillar, user, highwayTerritory);
}

async function  pillarManuallySave (event) {

  const coords = coordinatesManuallyPillae.split(',').map(coord => parseFloat(coord.trim()));    
     if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          
        WritePillarManuallyCanton(event, coords[0], coords[1], selectedCanton, selectedRegoin, selectedArea, user, commentTextAreaRefPillar, selectedOwnerPillar,
          cantonPillarRefresh, setCoordinatesManuallyPillae, showSnackbar );

     } else {
       showSnackbar(`Введите корректные координаты в формате "50.4488, 30.5255"`, 'snackbarWarning');
     }
}
//#endregion

//#region МУФТА

function toggleVisibilityCoupling() {
  setIsVisibleCoupling(!isVisibleCoupling);
}

const handleCommentChangeCoupling = (event) => {
  setCommentCoupling(event.target.value);
}

const handleChangeCoupling = (event) => {
  const selectedCoupling = event.target.value;
  setSelectedCoupling(selectedCoupling);
};



async function couplingSave(event) {
  WriteCouplingHighway(event, coordinatesCoupling, selectedCoupling, commentTextAreaRefCoupling, 
    selectedCity, couplingMarker, showSnackbar, setCoordinatesCoupling, 
    setCommentCoupling, cantonCouplingRefresh, setSelectedCoupling,
    selectedRankCouling, setSelectedRankCoupling, user,highwayTerritory);
 }
//#endregion

function toggleVisibilityFob() {
  setIsVisibleFob(!isVisibleFob);
}

const handleCommentChangeFob = (event) => {
  setCommentFob(event.target.value);
}

const handleChangeFob = (event) => {
  const selectedFob = event.target.value;
  setSelectedFob(selectedFob);
};

async function fobSave(event) {
  WriteFobHighway(event, coordinatesFob, selectedFob, commentTextAreaRefFob, selectedCity, fobMarker,
    showSnackbar, setCoordinatesFob, setCommentFob, cantonFobRefresh,
    setSelectedFob,selectedRankFob, setSelectedRankFob, user,highwayTerritory);
}


//#endregion

async function passiveNodeSave(event) {
  WritePassiveNodeHighway(event, coordinatesPassiveNode, selectedCity, passiveNodeMarker, showSnackbar, 
    setCoordinatesPassiveNode,cantonPassiveNodeRefresh, user, highwayTerritory);
}

//#endregion

//#region ПОН-БОКС


//#region ПОН-БОКС
function toggleVisibilityPonBox() {
  setIsVisiblePonBox(!isVisiblePonBox);
}

const handleChangePonBox = (event) => {
  const selectedPonBox = event.target.value;
  setSelectedPonBox(selectedPonBox);
};

const handleCommentChangePonBox = (event) => {
  setCommentPonBox(event.target.value);
}

async function ponBoxSave(event) {
  WritePonBoxHighway(event, coordinatesPonBox, selectedPonBox, commentTextAreaRefPonBox, selectedCity, ponBoxMarker,
    showSnackbar, setCoordinatesPonBox, setCommentPonBox,cantonPonBoxRefresh,
    setSelectedPonBox, user,highwayTerritory);
}

//#endregion

//Узел
function toggleVisibilityPassiveNode() {
  setIsVisiblePassiveNode(!isVisiblePassiveNode);
}

useEffect(() => {
  const fetchData = async () => {
    try {
      const [
        cableData,
        cableTypeData,
        couplingData,
        fobData,
        ponBoxData,
        rankCableData,
        rankComponentData,
        contractorData,
        ownerWellData,
        ownerPillarData,
      ] = await Promise.all([
        loadingCableDataComponent(),
        loadingCableTypeDataComponent(),
        loadingCouplingDataComponent(),
        loadingFobDataComponent(),
        loadingPonBoxDataComponent(),
        loadingRankCableDataComponent(),
        loadingRankComponentDataComponent(),
        loadingContractorDataComponent(),
        loadingOwnerWellDataComponent(),
        loadingOwnerPillarDataComponent(),
      ]);

      setCableData(cableData);
      setCableTypeData(cableTypeData);
      setCouplingData(couplingData);
      setFobData(fobData);
      setPonBoxData(ponBoxData);
      setRankCableData(rankCableData);
      setRankComponentData(rankComponentData);
      setContractorData(contractorData);
      setOwnerWellData(ownerWellData);
      setOwnerPillarData(ownerPillarData);
    } catch (error) {
      console.error("Ошибка загрузки данных:", error);
    }
  };

  fetchData();
}, []);
//#region ЗАГРУЗКА ДАННЫХ

 
  return (
    <Drawer
      open={openEditCantonDrawer}
      onClose={toggleEditCantonDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar' }}     
    >
      <div className="divTitleDrawer">
            <p className='textTitleDrawer'>Режим внесения</p>
            <p className='textTitleDrawer'>округ / регион / ветка</p>
      </div>
      <List  >
        <div className='divBodyDrawer'>
          <p className='textTitleDrawer'>Оптоволоконный кабель</p>

          {/* Кабель */}
          <CableContainerCanton
            toggleVisibilityCable={toggleVisibilityCable}
            isVisibleCable={isVisibleCable}
            cableData={cableData}     
            handleCableSelectChange={handleCableSelectChange}
            cableTypeData={cableTypeData}
            handleLineStyleSelectChange={handleLineStyleSelectChange}
            contractorData={contractorData}
            selectedContractor={selectedContractor}
            handleChangeContractor={handleChangeContractor}
            commentCable={commentCable}
            commentTextAreaRefCable={commentTextAreaRefCable}
            handleCommentChangeCable={handleCommentChangeCable}
            isLineDrawing={isLineDrawing}
            handleStartDrawing={handleStartDrawing}
            handleStopDrawing={handleStopDrawing}
            handleCableSave={handleCableSave}
            selectedCable={selectedCable}
            handleChangeCableSelect={handleChangeCableSelect}
            selectedTypeCable={selectedTypeCable}
            handleChangeCableType={handleChangeCableType}
            rankCableData={rankCableData}
            handleChangeRankCable={handleChangeRankCable}
            selectedRankCable={selectedRankCable}
            role={role}
            selectedGroup={selectedGroup}
            setSelectedGroup={setSelectedGroup}
            setSelectedContractor={setSelectedContractor}
            setSelectedTypeCable={setSelectedTypeCable}
            isSubway={isSubway}
            setIsSubway={setIsSubway}
          />         
       </div>

        <div className="divBodyDrawer">
          <p className='textTitleDrawer'>Коммуникации</p>

              {/* Колодец */}
             { role.role != ROLE_SENIOR_MASTER && ( 
              <ManholeContainerSummit
                 toggleVisibilityManhole={toggleVisibilityManhole}
                 isVisibleManhole={isVisibleManhole}
                 commentManhole={commentManhole}
                 commentTextAreaRefManhole={commentTextAreaRefManhole}
                 handleCommentChangeManhole={handleCommentChangeManhole}
                 toggleManholeMarker={toggleManholeMarker}
                 manholeMarker={manholeMarker}
                 wellSave={wellSave}
                 ownerWellData={ownerWellData}
                 handleChangeOwnerWell={handleChangeOwnerWell}
                 selectedOwnerWell={selectedOwnerWell}
              />
             )}

            {/* Опора */}
            <PillarContainerSummit
                  toggleVisibilityPillar={toggleVisibilityPillar}
                  isVisiblePillar={isVisiblePillar}
                  commentPillar={commentPillar}
                  commentTextAreaRefPillar={commentTextAreaRefPillar}
                  handleCommentChangePillar={handleCommentChangePillar}
                  togglePillarMarker={togglePillarMarker}
                  pillarMarker={pillarMarker}
                  pillarSave={pillarSave}
                  ownerPillarData={ownerPillarData}
                  handleChangeOwnerPillar={handleChangeOwnerPillar}
                  selectedOwnerPillar={selectedOwnerPillar}
                  pillarManuallySave={pillarManuallySave}
                  handleInputChangePillar={handleInputChangePillar}
                  coordinatesManuallyPillae={coordinatesManuallyPillae}
                  toggleManualInput={toggleManualPillarInput}
                  manualInputEnabledPillar={manualInputEnabledPillar}
              />
           
           {/* Муфта */}
           <CouplingContainerCanton
             toggleVisibilityCoupling={toggleVisibilityCoupling}
             isVisibleCoupling={isVisibleCoupling}
             couplingData={couplingData}
             handleChangeCoupling={handleChangeCoupling}
             selectedCoupling={selectedCoupling}
             commentCoupling={commentCoupling}
             commentTextAreaRefCoupling={commentTextAreaRefCoupling}
             handleCommentChangeCoupling={handleCommentChangeCoupling}
             toggleCouplingMarker={toggleCouplingMarker}
             couplingMarker={couplingMarker}
             couplingSave={couplingSave}
             rankComponentData={rankComponentData}
             handleChangeRankComponentCoupling={handleChangeRankComponentCoupling}
             selectedRankCouling={selectedRankCouling}
           />
              
          {/* Фоб */}
          <FobContainerCanton
             toggleVisibilityFob={toggleVisibilityFob}
             isVisibleFob={isVisibleFob}
             fobData={fobData}
             handleChangeFob={handleChangeFob}
             selectedFob={selectedFob}
             commentFob={commentFob}
             commentTextAreaRefFob={commentTextAreaRefFob}
             handleCommentChangeFob={handleCommentChangeFob}
             toggleFobMarker={toggleFobMarker}
             fobMarker={fobMarker}
             fobSave={fobSave}
             rankComponentData={rankComponentData}
             handleChangeRankComponentFob={handleChangeRankComponentFob}
             selectedRankFob={selectedRankFob}
          />

           {/* Пон-бокс */}
           <PonBoxContainerCanton
              toggleVisibilityPonBox={toggleVisibilityPonBox}
              isVisiblePonBox={isVisiblePonBox}
              ponboxData={ponboxData}
              handleChangePonBox={handleChangePonBox}
              selectedPonBox={selectedPonBox}
              commentPonBox={commentPonBox} 
              commentTextAreaRefPonBox={commentTextAreaRefPonBox}
              handleCommentChangePonBox={handleCommentChangePonBox}
              togglePonBoxMarker={togglePonBoxMarker}
              ponBoxMarker={ponBoxMarker}
              ponBoxSave={ponBoxSave}            
          />

           {/* Пассивный узел */}
        {(role.role === ROLE_ENGINNER || role.role === ROLE_ADMIN) && (
          <PassiveNodeContainerCanton
             toggleVisibilityPassiveNode={toggleVisibilityPassiveNode}
             isVisiblePassiveNode={isVisiblePassiveNode}
             togglePassiveNodeMarker={togglePassiveNodeMarker}
             passiveNodeMarker={passiveNodeMarker}
             passiveNodeSave={passiveNodeSave}
          />
          )}

        </div>
      </List>
       
      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        ContentProps={{
          style: {
            backgroundColor: snackbarClass === 'snackbarWarning' ? 'rgb(235, 235, 187)' : 'rgb(193, 255, 174)',
            color: 'black'
          }
        }}
      />

    </Drawer>    
  );
};

export default DrawerMenuEditCanton;